module.exports = __webpack_public_path__ + "static/media/cupoy.1172bc35.jpg";